<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { ref, computed } from 'vue'
import DeptTag from './DeptTag.vue'
import DeptPicker from './DeptPicker.vue'

const $props = defineProps({
  modelValue: {
    type: [Array, String, Number],
    default: undefined
  },
  multiple: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: '请选择部门'
  }
})

const $emits = defineEmits(['update:modelValue'])

const pickerRef = ref()
const disabled = computed(() => $props.disabled)

const valueArr = computed(() => {
  if (!$props.modelValue) return []
  return Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue]
})

const openPicker = () => {
  pickerRef.value?.open()
}

const onClose = (id) => {
  if (!$props.modelValue) return
  if ($props.multiple && Array.isArray($props.modelValue)) {
    const newValue = $props.modelValue.filter(item => {
      const itemId = typeof item === 'object' ? item.id : item
      return String(itemId) !== String(id)
    })
    $emits('update:modelValue', newValue)
  } else {
    $emits('update:modelValue', null)
  }
}
</script>

<template>
  <DeptPicker ref="pickerRef" :multiple="multiple" :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" />
  <div class="dept-wrapper">
    <el-button
      class="dept-btn-item"
      :disabled="disabled"
      @click="openPicker"
      circle
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
      </svg>
    </el-button>
    <DeptTag
      v-for="item in valueArr"
      :closable="!disabled"
      :key="typeof item === 'object' ? item.id : item"
      :id="typeof item === 'object' ? item.id : item"
      :name="typeof item === 'object' ? item.name : ''"
      @close="onClose(typeof item === 'object' ? item.id : item)"
    />
    <el-text v-show="!modelValue || (Array.isArray(modelValue) && modelValue.length === 0)" class="placeholder">
      {{ placeholder }}
    </el-text>
  </div>
</template>

<style scoped lang="scss">
.dept-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 7px;
  gap: 7px;
  min-width: 0;
  min-height: 32px;
  max-height: 72px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid var(--el-input-border-color, #dcdfe6);
  border-radius: var(--el-input-border-radius, var(--el-border-radius-base));
  background-color: var(--el-input-bg-color, var(--el-fill-color-blank));

  &:hover {
    border-color: var(--el-input-hover-border-color, var(--el-border-color-hover));
  }

  .placeholder {
    color: var(--el-text-color-placeholder);
  }

  .dept-btn-item {
    border-style: dashed;

    &:hover {
      border-style: solid;
    }
  }
}
</style>
